<template>
  <div>
    <div class="es-op-box">
      <el-select style="float: left"
                 class="query"
                 size="small"
                 v-model="queryObj.typeId"
                 placeholder="请选择设备类型"
                 clearable
                 filterable
                 @clear="() => {
            this.queryObj.pageNum = 1;
            delete this.queryObj.typeId;
            loadInsAssetTimeList();
          }
          "
                 @change="() => {
      this.queryObj.pageNum = 1;
      loadInsAssetTimeList();
    }
    ">
        <el-option v-for="item in types"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
        </el-option>
      </el-select>
      <el-select style="float: left"
                 class="query"
                 size="small"
                 v-model="queryObj.systemId"
                 placeholder="请选择系统专业"
                 clearable
                 filterable
                 @clear="() => {
            this.queryObj.pageNum = 1;
            delete this.queryObj.systemId;
            loadInsAssetTimeList();
          }
          "
                 @change="() => {
      this.queryObj.pageNum = 1;
      loadInsAssetTimeList();
    }
    ">
        <el-option v-for="item in systems"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
        </el-option>
      </el-select>
      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right: 6px"
                 @click="add_init">新增</el-button>
      <es-delete @del="del()"
                 type="button"></es-delete>
    </div>
    <el-table :data="pageData.list"
              ref="insAssettimeTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="sysName"
                       label="系统名称"> </el-table-column>
      <el-table-column prop="assetTypeName"
                       label="设备类型"> </el-table-column>
      <el-table-column prop="never"
                       label="频率"></el-table-column>
      <el-table-column prop="type"
                       label="类型">
        <template slot-scope="scope">
          <font v-if="scope.row.type == 1">日</font>
          <font v-if="scope.row.type == 2">月</font>
        </template>
      </el-table-column>
      <el-table-column prop="templateName"
                       label="模板名称"> </el-table-column>
      <el-table-column label="操作"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     width="1000px"
                     @change="(cpage) => {
          this.queryObj.pageNum = cpage;
          this.loadInsAssetTimeList();
        }
        ">
      </es-pagination>
    </div>
    <!--编辑设备巡检规则-->
    <el-dialog :visible.sync="setTimeVisible"
               @closed="() => { this.$refs['setInsAssetForm'].clearValidate();this.flag = false; }"
               width="1200px">
      <span slot="title">
        <i class="el-icon-lock el-icon--left"></i>设备巡检规则
      </span>

      <el-form :model="insAssetTimeInfo"
               :rules="editRules"
               size="small"
               :inline="true"
               label-position="right"
               label-width="150px"
               ref="setInsAssetForm">
        <el-row :gutter="15">
          <el-col :span="6">
            <el-card class="card"
                     style="overflow: auto; height: calc(100vh - 350px)">
              <div slot="header"
                   class="card-header">
                <i class="el-icon-font el-icon-jiaoseliebiao el-icon--left"></i>组织机构
              </div>
              <div style="overflow: auto; height: calc(100vh - 415px)">
                <es-org-tree v-if="flag"
                             @clickByOrg="selectOrgIdsList"
                             :checkedKeys="checkedKeys"
                             :checkstrictly="false"
                             ref="orgTreeChildren"></es-org-tree>
              </div>
            </el-card>
          </el-col>
          <el-col :span="18"
                  style="overflow: auto; height: calc(100vh - 348px)">
            <el-row :gutter="15">
              <el-card class="card"
                       style="height: 200px">
                <div slot="header"
                     class="card-header">
                  <i class="el-icon-font el-icon-jiaoseliebiao el-icon--left"></i>设备信息
                </div>
                <el-form-item prop="sysId"
                              label="所属系统">
                  <el-select ref="systemSelect"
                             style="width: 200px"
                             v-model="insAssetTimeInfo.sysId"
                             placeholder="请选择所属系统"
                             @change="() => {this.selectAssetList()}"
                             clearable
                             filterable>
                    <el-option v-for="
                             item
                             in
                             systems"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="typeArrId"
                              label="设备类型">
                  <el-select ref="typeSelect"
                             style="width: 200px"
                             v-model="insAssetTimeInfo.typeArrId"
                             placeholder="请选择设备类型"
                             @change="() => {
                              this.selectAssetList()}"
                             clearable
                             multiple
                             filterable>
                    <el-option v-for="item in types"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="templateId"
                              label="模版">
                  <el-select ref="templateSelect"
                             style="width: 200px"
                             v-model="insAssetTimeInfo.templateId"
                             placeholder="请选择模版">
                    <el-option v-for="item in templateList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="never"
                              label="频率">
                  <el-input-number v-model="insAssetTimeInfo.never"
                                   :min="1"
                                   :max="31"
                                   placeholder="频率"
                                   style="width: 200px"
                                   clearable></el-input-number>
                </el-form-item>
                <el-form-item prop="type"
                              label="类型">
                  <el-radio-group v-model="insAssetTimeInfo.type"
                                  style="width: 200px">
                    <el-radio :label="1">日</el-radio>
                    <el-radio :label="2">月</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-card>
            </el-row>
            <el-row :gutter="15"
                    style="margin-top: 15px;">
              <el-card class="card"
                       style="overflow: auto; height: calc(100vh - 570px)">
                <div slot="header"
                     class="card-header">
                  <i class="el-icon-font el-icon-jiaoseliebiao el-icon--left"></i>不参与巡检设备
                </div>
                <el-transfer filterable
                             :titles="['巡检设备', '不参与设备']"
                             :filter-method="filterMethod"
                             filter-placeholder="请输入设备名称"
                             v-model="assetValue"
                             style="margin-top: 20px;margin-left: 10px;"
                             :data="assetList">
                </el-transfer>
              </el-card>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="setTimeVisible = false;">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   :loading="savingTimeAsset"
                   @click="submitEditAssetTime()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "insassettime",
  props: ["funcs"],
  data () {
    return {
      flag: false,
      systems: [],
      types: [],
      templateList: [],
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      insAssetTimeInfo: {}, //设备时间规则信息
      checkedKeys: [],
      editRules: {
        //验证条件
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        never: [{ required: true, message: "请输入频率", trigger: "blur" }],
        sysId: [{ required: true, message: "请选择系统", trigger: "blur" }],
        typeArrId: [{ required: true, message: "请选择设备类型", trigger: "blur" }],
        templateId: [{ required: true, message: "请选择模板", trigger: "blur" }],
      },
      assetList: [],
      assetValue: [],
      loading: false,
      setTimeVisible: false, //编辑设备巡检规则
      savingTimeAsset: false,
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    //页面初始化
    init () {
      this.loadSystemListAll();
      this.loadTypeListAll();
      this.inittemplate();
      this.loadInsAssetTimeList();
      // this.assetInsList();
    },
    //初始化系统下拉框
    loadSystemListAll () {
      this.$ajax
        .get("/base/system/list_all")
        .then((msg) => {
          this.systems = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //初始化设备类型下拉框
    loadTypeListAll () {
      this.$ajax
        .get("/base/assettype/list_all")
        .then((msg) => {
          this.types = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    assetInsList () {
      this.queryObj.keyWord = "172.20.1.13"
      this.$ajax
        .get("/buss/insAssetTime/assetInsMapList", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //从后台查询线路时间规则列表
    loadInsAssetTimeList () {
      this.loading = true;
      this.$ajax
        .get("/buss/insAssetTime/listAssetTime", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    add_init () {
      this.insAssetTimeInfo = {};
      this.$set(this.insAssetTimeInfo, "type", 1);
      this.checkedKeys = [];
      this.assetList = [];
      this.assetValue = [];
      this.flag = true;
      this.setTimeVisible = true;
    },
    selectOrgIdsList (orgIds) {
      if (orgIds != null && orgIds != []) {
        this.insAssetTimeInfo.orgTree = orgIds.join(",");
      }
      this.selectAssetList();
    },
    set_auth_org () {
      this.flag = false;
      this.checkedKeys = [];
      this.flag = true;
    },
    inittemplate () {
      this.$ajax.get('/buss/instemplate/list_all',).then(msg => {
        this.templateList = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    filterMethod (query, item) {
      return item.label.indexOf(query) > -1;
    },
    edit_init (row) {
      this.flag = true;
      this.setTimeVisible = true;
      this.insAssetTimeInfo = JSON.parse(JSON.stringify(row))
      console.log("insAssetTimeInfo", this.insAssetTimeInfo);
      if (this.insAssetTimeInfo.assetTypeId != null && this.insAssetTimeInfo.assetTypeId != "") {
        var typeId = this.insAssetTimeInfo.assetTypeId.split(",");
        this.insAssetTimeInfo.typeArrId = typeId.map(Number);
      }
      if (this.insAssetTimeInfo.unassetIds != null && this.insAssetTimeInfo.unassetIds != "") {
        var value = this.insAssetTimeInfo.unassetIds.split(",");
        this.assetValue = value.map(Number);
      }
      if (this.insAssetTimeInfo.orgTree != null && this.insAssetTimeInfo.orgTree != "") {
        var checkedKey = this.insAssetTimeInfo.orgTree.split(",");
        this.checkedKeys = checkedKey.map(Number);
      }
      let _this = this;
      setTimeout(function () {
        _this.selectAssetList();
      }, 1000);

    },
    selectAssetList () {
      this.assetList = [];
      // this.assetValue = [];
      const assetTypeNamearr = this.$refs.typeSelect.selected.map(
        (v) => v.label
      );
      if (this.insAssetTimeInfo.typeArrId != null && this.insAssetTimeInfo.typeArrId != []) {
        this.insAssetTimeInfo.assetTypeId = this.insAssetTimeInfo.typeArrId.join(",");
        this.insAssetTimeInfo.assetTypeName = assetTypeNamearr.join(",");
      }
      if (this.insAssetTimeInfo.orgTree != null && this.insAssetTimeInfo.orgTree != "") {
        this.$ajax
          .get("/base/asset/list_no_page", {
            orgIds: this.insAssetTimeInfo.orgTree,
            typeId: this.insAssetTimeInfo.assetTypeId,
            systemId: this.insAssetTimeInfo.sysId,
          })
          .then((msg) => {
            for (var i = 0; i < msg.length; i++) {
              this.assetList.push({
                label: msg[i].name,
                key: msg[i].id,
                pinyin: msg[i].id + "",
              })
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }
    },
    //保存设备巡检规则信息
    submitEditAssetTime () {
      this.$refs["setInsAssetForm"].validate((valid) => {
        if (valid) {
          this.insAssetTimeInfo.sysName = this.$refs.systemSelect.selected.label;
          this.insAssetTimeInfo.templateName = this.$refs.templateSelect.selected.label;
          const assetTypeNamearr = this.$refs.typeSelect.selected.map(
            (v) => v.label
          );
          if (this.insAssetTimeInfo.typeArrId != null && this.insAssetTimeInfo.typeArrId != []) {
            this.insAssetTimeInfo.assetTypeId = this.insAssetTimeInfo.typeArrId.join(",");
            this.insAssetTimeInfo.assetTypeName = assetTypeNamearr.join(",");
          }
          if (this.assetValue != null && this.assetValue != []) {
            this.insAssetTimeInfo.unassetIds = this.assetValue.join(",");
          }
          let url = "/buss/insAssetTime/addAssetTime";
          if (this.insAssetTimeInfo.id != null) {
            url = "/buss/insAssetTime/editAssetTime";
          }
          this.saving = true;
          this.$ajax
            .post(url, this.insAssetTimeInfo)
            .then((msg) => {
              this.savingTimeAsset = false;
              this.loadInsAssetTimeList();
              this.setTimeVisible = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.savingTimeAsset = false;
            });
        }
      });
    },
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["insAssettimeTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/insAssetTime/deleteAssetTime', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadInsAssetTimeList();
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
};
</script>
<style>
.el-transfer-panel__body {
  height: calc(100vh - 730px);
}
.el-transfer-panel {
  width: 330px;
}
.el-transfer-panel__list.is-filterable {
  height: calc(100vh - 770px);
  /* height: 194px; */
  padding-top: 0;
}
</style>
